(() => {
  /* Vehicle fitment + PDP notice visibility. */
  const STORAGE_KEY = "vehicle-fitment";

  const parseJson = (value) => {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  };

  const normalize = (value) =>
    String(value ?? "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

  const readStoredSelection = () => {
    const data = parseJson(localStorage.getItem(STORAGE_KEY) || "");
    if (!data || typeof data !== "object") return null;

    const brand = typeof data.brand === "string" ? data.brand.trim() : "";
    const model = typeof data.model === "string" ? data.model.trim() : "";
    return brand || model ? { brand, model } : null;
  };

  const storeSelection = ({ brand = "", model = "" } = {}) => {
    const cleanBrand = String(brand || "").trim();
    const cleanModel = String(model || "").trim();

    if (!cleanBrand && !cleanModel) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        brand: cleanBrand,
        model: cleanModel,
        updatedAt: Date.now(),
      }),
    );
  };

  const getProductFitment = (noticeEl) => {
    const listRaw = noticeEl?.dataset?.brandList;
    const list = listRaw ? parseJson(listRaw) : null;

    const brands = Array.isArray(list) ? list.filter(Boolean).map(String) : [];

    const modelListRaw = noticeEl?.dataset?.modelList;
    const modelList = modelListRaw ? parseJson(modelListRaw) : null;

    const models = Array.isArray(modelList)
      ? modelList.filter(Boolean).map(String)
      : [];

    const isUniversal = brands.some((b) => normalize(b) === "universal");

    return { brands, models, isUniversal };
  };

  const selectionMatchesProduct = (selection, productFitment) => {
    if (productFitment.isUniversal) return true;

    if (!productFitment.brands.length && !productFitment.models.length)
      return false;

    const selectedBrand = normalize(selection.brand);
    const selectedModel = normalize(selection.model);

    const brandOk = !selectedBrand
      ? true
      : productFitment.brands.some((b) => normalize(b) === selectedBrand);

    const modelOk = !selectedModel
      ? true
      : productFitment.models.some((m) => normalize(m) === selectedModel);

    return brandOk && modelOk;
  };

  const setNoticeText = (noticeEl, selection) => {
    const brandEl = noticeEl.querySelector("[data-fitment-brand]");
    const modelEl = noticeEl.querySelector("[data-fitment-model]");
    if (brandEl) brandEl.textContent = selection.brand || "";
    if (modelEl)
      modelEl.textContent = selection.model ? ` ${selection.model}` : "";
  };

  const updateNotice = (noticeEl, selection) => {
    if (!(noticeEl instanceof HTMLElement)) return;

    if (!selection) {
      noticeEl.hidden = true;
      return;
    }

    const productFitment = getProductFitment(noticeEl);
    const match = selectionMatchesProduct(selection, productFitment);
    noticeEl.hidden = !match;
    if (match) setNoticeText(noticeEl, selection);
  };

  const updateAllNotices = (selection) => {
    document
      .querySelectorAll("[data-fitment]")
      .forEach((el) => updateNotice(el, selection));
  };

  const readSelectionFromQuickFilter = (quickFilterEl) => {
    const selects = Array.from(
      quickFilterEl.querySelectorAll("select.select__select"),
    );
    const selected = selects
      .map((s) => {
        const opt = s.selectedOptions?.[0];
        if (!opt || !s.value) return "";
        return (opt.textContent || "").replace(/\s+/g, " ").trim();
      })
      .filter(Boolean);

    if (!selected.length) return null;

    return {
      brand: selected[0] || "",
      model: selected.slice(1).join(", "),
    };
  };

  const onQuickFilterSubmitClick = (event) => {
    const submitButton = event.target?.closest?.(
      "quick-filter .js-filter-submit",
    );
    if (!(submitButton instanceof HTMLButtonElement) || submitButton.disabled)
      return;

    const quickFilterEl = submitButton.closest("quick-filter");
    if (!quickFilterEl) return;

    const selection = readSelectionFromQuickFilter(quickFilterEl);
    if (!selection) return;

    storeSelection(selection);
    updateAllNotices(selection);
  };

  const stored = readStoredSelection();
  updateAllNotices(stored);

  const observer = new MutationObserver((mutations) => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.("[data-fitment]")) updateNotice(node, stored);
        node
          .querySelectorAll?.("[data-fitment]")
          .forEach((el) => updateNotice(el, stored));
      }
    }
  });

  try {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  } catch {
    // no-op
  }

  document.addEventListener("click", onQuickFilterSubmitClick, true);
})();
